import React from 'react';
import { MdDashboard, MdInventory, MdShoppingCart, MdReceipt, MdBarChart, MdFileDownload, MdFileUpload } from 'react-icons/md';

type ActiveTab = 'dashboard' | 'inventory' | 'transactions' | 'reports' | 'inventory-input' | 'orders' | 'receiving' | 'shipping';

interface MenuProps {
  activeTab: ActiveTab;
  setActiveTab: (tab: ActiveTab) => void;
  isOpen: boolean;
  onToggle: () => void;
}

export default function Menu({ activeTab, setActiveTab, isOpen, onToggle }: MenuProps) {
  const menuItems = [
    { id: 'dashboard', icon: <MdDashboard />, label: 'ダッシュボード' },
    { id: 'orders', icon: <MdShoppingCart />, label: '受発注入力' },
    { id: 'receiving', icon: <MdFileDownload />, label: '入荷入力' },
    { id: 'shipping', icon: <MdFileUpload />, label: '出荷入力' },
    { id: 'inventory', icon: <MdInventory />, label: '在庫一覧' },
    { id: 'transactions', icon: <MdReceipt />, label: '入出庫履歴' },
    { id: 'reports', icon: <MdBarChart />, label: 'データ分析' }
  ];

  return (
    <aside className={`sidebar-menu ${isOpen ? 'open' : 'closed'}`}>
      <div className="menu-header">
        <div className="menu-logo">
          <button 
            className="menu-logo-icon" 
            onClick={onToggle}
            title={isOpen ? 'メニューを閉じる' : 'メニューを開く'}
          >
            {isOpen ? '◀' : '▶'}
          </button>
          {isOpen && (
            <div className="menu-logo-text" onClick={() => setActiveTab('dashboard')}>
              <h3>メニュー</h3>
            </div>
          )}
        </div>
      </div>
      
      <nav className="menu-nav">
        <ul className="menu-list">
          {menuItems.map((item) => (
            <li key={item.id} className="menu-item">
              <button
                className={`menu-button ${activeTab === item.id ? 'active' : ''}`}
                onClick={() => setActiveTab(item.id as ActiveTab)}
                title={!isOpen ? item.label : undefined}
              >
                <span className="menu-icon">{item.icon}</span>
                {isOpen && (
                  <div className="menu-content">
                    <span className="menu-label">{item.label}</span>
                  </div>
                )}
              </button>
            </li>
          ))}
        </ul>
      </nav>
    </aside>
  );
}
